import { render, staticRenderFns } from "./TreatmentsOverview.vue?vue&type=template&id=42fec844&scoped=true"
import script from "./TreatmentsOverview.vue?vue&type=script&lang=ts"
export * from "./TreatmentsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fec844",
  null
  
)

export default component.exports